import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';

import {
  Chart,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const COLORS = ['#424949', '#515a5a', '#616a6b', '#707b7c', '#7f8c8d', '#99a3a4', '#b2babb', '#ccd1d1'];

const API_URL = process.env.REACT_APP_API_URL;

const AcumuladoMesTable = () => {
  const [chartData, setChartData] = useState(() => {
    // Intenta cargar desde localStorage al iniciar
    const stored = localStorage.getItem('acumuladoMesChartData');
    return stored ? JSON.parse(stored) : { labels: [], datasets: [] };
  });

  useEffect(() => {
    const fetchAcumuladoMes = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await fetch(`${API_URL}/acumulado-mes-rpm`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        console.log('[AcumuladoMesTable] Datos recibidos:', result);
        
        const labels = result.map(item => item.machineId || item.dispositivoId);
        const data = result.map(item => item.acumuladoMes || 0);

        const chartDataObj = {
          labels,
          datasets: [
            {
              label: 'Acumulado RPM Mes',
              data,
              backgroundColor: labels.map((_, i) => COLORS[i % COLORS.length]),
              borderRadius: 2,
            }
          ]
        };
        setChartData(chartDataObj);
        localStorage.setItem('acumuladoMesChartData', JSON.stringify(chartDataObj));
      } catch (error) {
        console.error('[AcumuladoMesTable] Error fetching acumulado mes:', error);
      }
    };
    fetchAcumuladoMes();
    const interval = setInterval(fetchAcumuladoMes, 300000); // Actualiza cada 5 minutos

    return () => clearInterval(interval);
  }, []);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        labels: { color: '#8ab0cc', font: { family: 'Roboto', size: 9 } }
      },
      title: {
        display: true,
        text: 'Acumulado del Mes por Máquina',
        color: '#8ab0cc',
        font: { family: 'Roboto', size: 10 }
      }
    },
    scales: {
      x: {
        grid: { color: 'rgba(30,90,180,0.2)', borderDash: [], lineWidth: 0.3 },
        ticks: { color: '#8ab0cc', font: { family: 'Roboto', size: 13 } }
      },
      y: {
        grid: { color: 'rgba(30,90,180,0.2)', borderDash: [], lineWidth: 0.3 },
        ticks: { color: '#8ab0cc', font: { family: 'Roboto', size: 13 } }
      }
    }
  };

  return (
    <Bar data={chartData} options={options} height={280} />
  );
};

export default AcumuladoMesTable;